import React from "react";

// Gold serpent logo (brand asset) + RAE ENTERPRISE LLC text
export default function Logo({ compact = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src="/logo-serpent.png"
        alt="Rae Enterprise LLC gold serpent logo"
        className="h-10 w-auto object-contain"
        draggable={false}
      />
      {!compact && (
        <div className="leading-[1.05] tracking-[0.18em]">
          <div className="text-[10px] md:text-[11px] font-medium text-white">RAE</div>
          <div className="text-[10px] md:text-[11px] font-medium text-white">ENTERPRISE</div>
          <div className="text-[10px] md:text-[11px] font-medium text-[#d4af37]">LLC</div>
        </div>
      )}
    </div>
  );
}
